import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Fragment } from "react";
import {
  ArrivingFailed,
  ArrivingPending,
} from "@/client/components/arriving-layout";
import { PENDING_MS } from "@/client/lib/pending";
import { useFollowActiveCompany } from "@/client/lib/use-follow-active-company";
import { resumeOnboarding } from "@/features/onboarding/onboarding-query";

/**
 * No company in the address: the guard checks the session's company and moves the address to the
 * step the server holds. A company switch in another tab is followed as on a company's screens.
 */
export const Route = createFileRoute("/_authenticated/onboarding")({
  pendingMs: PENDING_MS,
  pendingComponent: ArrivingPending,
  errorComponent: ArrivingFailed,
  beforeLoad: ({ context, location, preload }) =>
    resumeOnboarding(
      context.queryClient,
      location.pathname,
      location.href,
      preload,
    ),
  component: Onboarding,
});

/**
 * Keyed by company: following a switch lands on the same route, and without a remount what was
 * typed would be saved into the other company.
 */
function Onboarding() {
  useFollowActiveCompany();
  const { onboardingCompany } = Route.useRouteContext();
  return (
    <Fragment key={onboardingCompany}>
      <Outlet />
    </Fragment>
  );
}
